// Config for the six Help Hub category hub pages. Pure data (no asset
// imports) so it can be consumed by both the React pages and the prerender
// script (routes.ts). Hero images are looked up client-side from
// CATEGORY_HERO_IMAGES keyed by `category`.

export interface CategoryPageConfig {
  /** Matches blogPosts[].category exactly. */
  category: string;
  /** URL segment: /category/<slug>/ */
  slug: string;
  /** H1 / hero title. */
  title: string;
  /** Full <title> tag (kept <= 60 chars with brand). */
  seoTitle: string;
  /** Meta description (kept <= 165 chars, unique). */
  description: string;
  /** Hero subtitle. */
  intro: string;
  /** Primary service CTA shown under the article list. */
  serviceLink: { label: string; href: string };
}

export const categoryPages: CategoryPageConfig[] = [
  {
    category: "Roofing",
    slug: "lancaster-roofing-contractor",
    title: "Lancaster Roofing Contractor",
    seoTitle: "Lancaster Roofing Contractor | Graystone Roofing & Siding",
    description:
      "Every roofing article from Graystone: repair, replacement, materials, and hiring advice for Lancaster County homeowners. Local, GAF certified, since 2007.",
    intro:
      "Expert roofing articles and resources for Lancaster County homeowners from Graystone Roofing & Siding.",
    serviceLink: { label: "View Roofing Services", href: "/services/roofing-company-lancaster-pa/" },
  },
  {
    category: "Siding",
    slug: "lancaster-siding-contractor",
    title: "Lancaster Siding Contractor",
    seoTitle: "Lancaster Siding Contractor | Graystone Roofing & Siding",
    description:
      "Every siding article from Graystone: vinyl, insulated, and fiber cement guides, maintenance tips, and hiring advice for Lancaster County homeowners.",
    intro:
      "Expert siding articles and resources for Lancaster County homeowners from Graystone Roofing & Siding.",
    serviceLink: {
      label: "View Siding Services",
      href: "/services/siding-contractor-lancaster-pa/",
    },
  },
  {
    category: "Gutters",
    slug: "lancaster-gutter-contractor",
    title: "Lancaster Gutter Contractor",
    seoTitle: "Lancaster Gutter Contractor | Graystone Roofing & Siding",
    description:
      "Every gutter article from Graystone: seamless gutters, gutter guards, downspouts, and drainage fixes for Lancaster County homes. Local experts since 2007.",
    intro:
      "Gutter and drainage articles for Lancaster County homeowners from Graystone Roofing & Siding.",
    serviceLink: {
      label: "View Gutter Services",
      href: "/services/gutter-installation-lancaster-pa-york-pa/",
    },
  },
  {
    category: "Storm Damage",
    slug: "storm-damage-insurance-claims",
    title: "Storm Damage & Insurance Claims",
    seoTitle: "Storm Damage & Insurance Claim Guides | Graystone Roofing",
    description:
      "Storm damage and insurance claim guides for Lancaster County homeowners: hail, wind, emergency tarping, adjusters, and the claims process explained.",
    intro:
      "Hail, wind, and insurance claim guidance for Lancaster County homeowners from Graystone Roofing & Siding.",
    serviceLink: {
      label: "Storm Damage Services",
      href: "/services/roofing-storm-damage-lancaster-pa/",
    },
  },
  {
    category: "Costs",
    slug: "roofing-siding-costs",
    title: "Roofing & Siding Costs",
    seoTitle: "Roofing & Siding Cost Guides | Graystone Roofing & Siding",
    description:
      "Roofing and siding cost guides for Lancaster County: replacement pricing, financing, quotes, and how to compare contractors without surprises.",
    intro:
      "Pricing, financing, and contractor-vetting guides for Lancaster County homeowners from Graystone Roofing & Siding.",
    serviceLink: {
      label: "Try the Cost Calculator",
      href: "/roofing-siding-cost-calculator-lancaster-pa/",
    },
  },
  {
    category: "Maintenance",
    slug: "roof-maintenance",
    title: "Roof & Exterior Maintenance",
    seoTitle: "Roof Maintenance Guides | Graystone Roofing & Siding",
    description:
      "Roof and exterior maintenance guides for Lancaster County homeowners: inspections, cleaning, moss, ventilation, and seasonal care that extends roof life.",
    intro:
      "Inspection, cleaning, and seasonal care guides for Lancaster County homeowners from Graystone Roofing & Siding.",
    serviceLink: {
      label: "Schedule a Roof Inspection",
      href: "/services/roofing-inspection-lancaster-pa/",
    },
  },
];

export function getCategoryBySlug(slug: string): CategoryPageConfig | undefined {
  return categoryPages.find((c) => c.slug === slug);
}
